// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CSS Variables - Design System
 * Centralized design tokens for consistent styling
 */

:root {
  /* Color Palette - Primary */
  --color-primary-50: #eff6ff;
  --color-primary-100: #dbeafe;
  --color-primary-200: #bfdbfe;
  --color-primary-300: #93c5fd;
  --color-primary-400: #60a5fa;
  --color-primary-500: #3b82f6;
  --color-primary-600: #2563eb;
  --color-primary-700: #1d4ed8;
  --color-primary-800: #1e40af;
  --color-primary-900: #1e3a8a;

  /* Color Palette - Success */
  --color-success-50: #f0fdf4;
  --color-success-100: #dcfce7;
  --color-success-200: #bbf7d0;
  --color-success-300: #86efac;
  --color-success-400: #4ade80;
  --color-success-500: #22c55e;
  --color-success-600: #10b981;
  --color-success-700: #15803d;
  --color-success-800: #166534;
  --color-success-900: #14532d;

  /* Color Palette - Warning */
  --color-warning-50: #fffbeb;
  --color-warning-100: #fef3c7;
  --color-warning-200: #fde68a;
  --color-warning-300: #fcd34d;
  --color-warning-400: #fbbf24;
  --color-warning-500: #f59e0b;
  --color-warning-600: #d97706;
  --color-warning-700: #b45309;
  --color-warning-800: #92400e;
  --color-warning-900: #78350f;

  /* Color Palette - Danger */
  --color-danger-50: #fef2f2;
  --color-danger-100: #fee2e2;
  --color-danger-200: #fecaca;
  --color-danger-300: #fca5a5;
  --color-danger-400: #f87171;
  --color-danger-500: #ef4444;
  --color-danger-600: #dc2626;
  --color-danger-700: #b91c1c;
  --color-danger-800: #991b1b;
  --color-danger-900: #7f1d1d;

  /* Color Palette - Neutral */
  --color-gray-50: #f9fafb;
  --color-gray-100: #f3f4f6;
  --color-gray-200: #e5e7eb;
  --color-gray-300: #d1d5db;
  --color-gray-400: #9ca3af;
  --color-gray-500: #6b7280;
  --color-gray-600: #4b5563;
  --color-gray-700: #374151;
  --color-gray-800: #1f2937;
  --color-gray-900: #111827;

  /* Color Palette - Slate */
  --color-slate-50: #f8fafc;
  --color-slate-100: #f1f5f9;
  --color-slate-200: #e2e8f0;
  --color-slate-300: #cbd5e1;
  --color-slate-400: #94a3b8;
  --color-slate-500: #64748b;
  --color-slate-600: #475569;
  --color-slate-700: #334155;
  --color-slate-800: #1e293b;
  --color-slate-900: #0f172a;

  /* Color Palette - Blue */
  --color-blue-50: #eff6ff;
  --color-blue-100: #dbeafe;
  --color-blue-200: #bfdbfe;
  --color-blue-300: #93c5fd;
  --color-blue-400: #60a5fa;
  --color-blue-500: #3b82f6;
  --color-blue-600: #2563eb;
  --color-blue-700: #1d4ed8;
  --color-blue-800: #1e40af;
  --color-blue-900: #1e3a8a;

  /* Color Palette - Purple */
  --color-purple-100: #f3e8ff;
  --color-purple-400: #c084fc;
  --color-purple-700: #7e22ce;
  --color-purple-900: #581c87;

  /* Color Palette - Red/Green for actions */
  --color-green-300: #86efac;
  --color-green-400: #4ade80;
  --color-green-600: #16a34a;
  --color-green-700: #15803d;
  
  --color-red-300: #fca5a5;
  --color-red-400: #f87171;
  --color-red-600: #dc2626;
  --color-red-700: #b91c1c;

  /* Font Weights */
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;

  /* Spacing Scale */
  --spacing-xs: 0.25rem;    /* 4px */
  --spacing-sm: 0.5rem;     /* 8px */
  --spacing-md: 1rem;       /* 16px */
  --spacing-lg: 1.5rem;     /* 24px */
  --spacing-xl: 2rem;       /* 32px */
  --spacing-2xl: 3rem;      /* 48px */
  --spacing-3xl: 4rem;      /* 64px */

  /* Typography */
  --font-family-base: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  --font-size-xs: 0.75rem;   /* 12px */
  --font-size-sm: 0.875rem;  /* 14px */
  --font-size-base: 1rem;    /* 16px */
  --font-size-lg: 1.125rem;  /* 18px */
  --font-size-xl: 1.25rem;   /* 20px */
  --font-size-2xl: 1.5rem;   /* 24px */
  --font-size-3xl: 1.875rem; /* 30px */
  --font-size-4xl: 2.25rem;  /* 36px */

  /* Border Radius */
  --radius-sm: 0.25rem;   /* 4px */
  --radius-md: 0.5rem;    /* 8px */
  --radius-lg: 0.75rem;   /* 12px */
  --radius-xl: 1rem;      /* 16px */
  --radius-full: 9999px;

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  /* Transitions */
  --transition-fast: 150ms ease-in-out;
  --transition-base: 200ms ease-in-out;
  --transition-slow: 300ms ease-in-out;

  /* Z-index Scale */
  --z-index-dropdown: 1000;
  --z-index-sticky: 1020;
  --z-index-fixed: 1030;
  --z-index-modal-backdrop: 1040;
  --z-index-modal: 1050;
  --z-index-popover: 1060;
  --z-index-tooltip: 1070;
}

/* Dark Mode Variables */
.dark {
  --color-bg-primary: #0f172a;
  --color-bg-secondary: #1e293b;
  --color-bg-tertiary: #334155;
  --color-text-primary: #f1f5f9;
  --color-text-secondary: #cbd5e1;
  --color-text-tertiary: #94a3b8;
}

/* Light Mode Variables */
:root:not(.dark) {
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #f8fafc;
  --color-bg-tertiary: #f1f5f9;
  --color-text-primary: #0f172a;
  --color-text-secondary: #475569;
  --color-text-tertiary: #64748b;
}

`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,0CAA0C;EAC1C,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,kBAAkB;EAClB,qBAAqB,KAAK,QAAQ;EAClC,oBAAoB,MAAM,QAAQ;EAClC,kBAAkB,QAAQ,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,mBAAmB,OAAO,SAAS;EACnC,mBAAmB,OAAO,SAAS;;EAEnC,eAAe;EACf,gGAAgG;EAChG,uBAAuB,IAAI,SAAS;EACpC,wBAAwB,GAAG,SAAS;EACpC,sBAAsB,KAAK,SAAS;EACpC,wBAAwB,GAAG,SAAS;EACpC,uBAAuB,IAAI,SAAS;EACpC,uBAAuB,IAAI,SAAS;EACpC,yBAAyB,EAAE,SAAS;EACpC,wBAAwB,GAAG,SAAS;;EAEpC,kBAAkB;EAClB,oBAAoB,IAAI,QAAQ;EAChC,mBAAmB,KAAK,QAAQ;EAChC,oBAAoB,IAAI,SAAS;EACjC,iBAAiB,OAAO,SAAS;EACjC,qBAAqB;;EAErB,YAAY;EACZ,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;;EAEtF,gBAAgB;EAChB,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;AAChC","sourcesContent":["/**\n * CSS Variables - Design System\n * Centralized design tokens for consistent styling\n */\n\n:root {\n  /* Color Palette - Primary */\n  --color-primary-50: #eff6ff;\n  --color-primary-100: #dbeafe;\n  --color-primary-200: #bfdbfe;\n  --color-primary-300: #93c5fd;\n  --color-primary-400: #60a5fa;\n  --color-primary-500: #3b82f6;\n  --color-primary-600: #2563eb;\n  --color-primary-700: #1d4ed8;\n  --color-primary-800: #1e40af;\n  --color-primary-900: #1e3a8a;\n\n  /* Color Palette - Success */\n  --color-success-50: #f0fdf4;\n  --color-success-100: #dcfce7;\n  --color-success-200: #bbf7d0;\n  --color-success-300: #86efac;\n  --color-success-400: #4ade80;\n  --color-success-500: #22c55e;\n  --color-success-600: #10b981;\n  --color-success-700: #15803d;\n  --color-success-800: #166534;\n  --color-success-900: #14532d;\n\n  /* Color Palette - Warning */\n  --color-warning-50: #fffbeb;\n  --color-warning-100: #fef3c7;\n  --color-warning-200: #fde68a;\n  --color-warning-300: #fcd34d;\n  --color-warning-400: #fbbf24;\n  --color-warning-500: #f59e0b;\n  --color-warning-600: #d97706;\n  --color-warning-700: #b45309;\n  --color-warning-800: #92400e;\n  --color-warning-900: #78350f;\n\n  /* Color Palette - Danger */\n  --color-danger-50: #fef2f2;\n  --color-danger-100: #fee2e2;\n  --color-danger-200: #fecaca;\n  --color-danger-300: #fca5a5;\n  --color-danger-400: #f87171;\n  --color-danger-500: #ef4444;\n  --color-danger-600: #dc2626;\n  --color-danger-700: #b91c1c;\n  --color-danger-800: #991b1b;\n  --color-danger-900: #7f1d1d;\n\n  /* Color Palette - Neutral */\n  --color-gray-50: #f9fafb;\n  --color-gray-100: #f3f4f6;\n  --color-gray-200: #e5e7eb;\n  --color-gray-300: #d1d5db;\n  --color-gray-400: #9ca3af;\n  --color-gray-500: #6b7280;\n  --color-gray-600: #4b5563;\n  --color-gray-700: #374151;\n  --color-gray-800: #1f2937;\n  --color-gray-900: #111827;\n\n  /* Color Palette - Slate */\n  --color-slate-50: #f8fafc;\n  --color-slate-100: #f1f5f9;\n  --color-slate-200: #e2e8f0;\n  --color-slate-300: #cbd5e1;\n  --color-slate-400: #94a3b8;\n  --color-slate-500: #64748b;\n  --color-slate-600: #475569;\n  --color-slate-700: #334155;\n  --color-slate-800: #1e293b;\n  --color-slate-900: #0f172a;\n\n  /* Color Palette - Blue */\n  --color-blue-50: #eff6ff;\n  --color-blue-100: #dbeafe;\n  --color-blue-200: #bfdbfe;\n  --color-blue-300: #93c5fd;\n  --color-blue-400: #60a5fa;\n  --color-blue-500: #3b82f6;\n  --color-blue-600: #2563eb;\n  --color-blue-700: #1d4ed8;\n  --color-blue-800: #1e40af;\n  --color-blue-900: #1e3a8a;\n\n  /* Color Palette - Purple */\n  --color-purple-100: #f3e8ff;\n  --color-purple-400: #c084fc;\n  --color-purple-700: #7e22ce;\n  --color-purple-900: #581c87;\n\n  /* Color Palette - Red/Green for actions */\n  --color-green-300: #86efac;\n  --color-green-400: #4ade80;\n  --color-green-600: #16a34a;\n  --color-green-700: #15803d;\n  \n  --color-red-300: #fca5a5;\n  --color-red-400: #f87171;\n  --color-red-600: #dc2626;\n  --color-red-700: #b91c1c;\n\n  /* Font Weights */\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n\n  /* Spacing Scale */\n  --spacing-xs: 0.25rem;    /* 4px */\n  --spacing-sm: 0.5rem;     /* 8px */\n  --spacing-md: 1rem;       /* 16px */\n  --spacing-lg: 1.5rem;     /* 24px */\n  --spacing-xl: 2rem;       /* 32px */\n  --spacing-2xl: 3rem;      /* 48px */\n  --spacing-3xl: 4rem;      /* 64px */\n\n  /* Typography */\n  --font-family-base: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  --font-size-xs: 0.75rem;   /* 12px */\n  --font-size-sm: 0.875rem;  /* 14px */\n  --font-size-base: 1rem;    /* 16px */\n  --font-size-lg: 1.125rem;  /* 18px */\n  --font-size-xl: 1.25rem;   /* 20px */\n  --font-size-2xl: 1.5rem;   /* 24px */\n  --font-size-3xl: 1.875rem; /* 30px */\n  --font-size-4xl: 2.25rem;  /* 36px */\n\n  /* Border Radius */\n  --radius-sm: 0.25rem;   /* 4px */\n  --radius-md: 0.5rem;    /* 8px */\n  --radius-lg: 0.75rem;   /* 12px */\n  --radius-xl: 1rem;      /* 16px */\n  --radius-full: 9999px;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n\n  /* Transitions */\n  --transition-fast: 150ms ease-in-out;\n  --transition-base: 200ms ease-in-out;\n  --transition-slow: 300ms ease-in-out;\n\n  /* Z-index Scale */\n  --z-index-dropdown: 1000;\n  --z-index-sticky: 1020;\n  --z-index-fixed: 1030;\n  --z-index-modal-backdrop: 1040;\n  --z-index-modal: 1050;\n  --z-index-popover: 1060;\n  --z-index-tooltip: 1070;\n}\n\n/* Dark Mode Variables */\n.dark {\n  --color-bg-primary: #0f172a;\n  --color-bg-secondary: #1e293b;\n  --color-bg-tertiary: #334155;\n  --color-text-primary: #f1f5f9;\n  --color-text-secondary: #cbd5e1;\n  --color-text-tertiary: #94a3b8;\n}\n\n/* Light Mode Variables */\n:root:not(.dark) {\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #f8fafc;\n  --color-bg-tertiary: #f1f5f9;\n  --color-text-primary: #0f172a;\n  --color-text-secondary: #475569;\n  --color-text-tertiary: #64748b;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
